import { FC, useEffect, useState } from "react";
import { GiPokecog } from 'react-icons/gi';
import { PageSizer, SizerMode } from "../../components/page/PageSizer";
import { PageContainer } from "../../components/page/PageContainer";
import { PageHeader } from '../../components/page/PageHeader';
import { TenantGrid } from "../tenantManagement/TenantGrid";
import { getVariable, useVariable } from '../../services/backstage/BackstageProvider';
import strings from './tenantManagement.translations';
import { CorsOriginGrid } from "./CorsOriginGrid";

export const TenantManagementPage: FC = () => {
  const name = useVariable('name');
  const [clientId, setClientId] = useState<string>();

  useEffect(() => {
    const load = async () => {
      const id = await getVariable("authIdentityClientId");
      setClientId(id);
    };
    load();
  }, []);

  return (
    <PageContainer customHeader={<PageHeader pageTitle={strings.tenantInfoTablesSection.title} icon={<GiPokecog />}/>}>
      <PageSizer className="relative flex-col flex gap-5" mode={SizerMode.PAGE}>
        <TenantGrid />
        {clientId && <CorsOriginGrid clientId={clientId}/>}
      </PageSizer>
    </PageContainer>
  );
};